export default "__VITE_ASSET__DnT5jeNL__"